import { render, staticRenderFns } from "./CustomerAddUserModal.vue?vue&type=template&id=7629cc07&scoped=true&"
import script from "./CustomerAddUserModal.vue?vue&type=script&lang=js&"
export * from "./CustomerAddUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7629cc07",
  null
  
)

export default component.exports